import {Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { CheckboxModel } from '../checkbox.model';
import { AbstractWorkflowFormComponent } from '../../@core/abstract-workflow-form-component';
import { COMPONENT_UI } from '../../workflow-components.models';

@Component({
    selector: 'abw-checkbox-form',
    providers: [
      {
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => CheckboxFormComponent),
        multi: true
      },
    ],
    templateUrl: './checkbox-form.component.html',
    styleUrls: ['./checkbox-form.component.scss']
})
export class CheckboxFormComponent extends AbstractWorkflowFormComponent<CheckboxModel, any[]> {
	onChecked(_event: any) {
    const value = this.model.componentUI == COMPONENT_UI.KENDO ? _event.target.value : (this.model.componentUI == COMPONENT_UI.IONIC ? _event.detail.value : '');
    const isChecked = this.model.componentUI == COMPONENT_UI.KENDO ? _event.target.checked : (this.model.componentUI == COMPONENT_UI.IONIC ? _event.detail.checked : false);
		if (this.value === undefined || this.value === null) { this.value = []; }
		const index = this.value.findIndex(v => v == value);
		if (isChecked === true && index == -1) {
			this.value.push(value);
		} else if (isChecked === false && index > -1) {
			this.value.splice(index, 1);
		}
		this.onValueChanged(this.value);
	}
}